import styled from '@emotion/styled';
import { List as _List, ListItem, ListItemText, Typography } from '@material-ui/core';
import Help from '@material-ui/icons/Help';
import { createElement, FC, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { Option, ProjectDetailsForShowFragment } from '../../../generated/graphql';
import theme from '../../../theme';
import { SPACING_UNIT } from '../../constant/spacing';

type Props = {
  project: ProjectDetailsForShowFragment;
  className?: string;
};

const PricingMerchandiseOptionsList: FC<Props> = ({ project, className }) => {
  // オプション商品は、CreativeFormat単位でデータ上は存在するが、実際にはUI上ではProject単位なため、1つ目のCreativeFormatのオプション商品を用いる
  const targetCreationSet = project.creationSet;
  const targetCreativeFormat = targetCreationSet ? targetCreationSet.creativeFormats[0] : null;
  const pricingMerchandiseOptions: Pick<
    Option,
    'name' | 'helpUrlForDirector' | 'helpUrlForDirector'
  >[] = targetCreativeFormat ? targetCreativeFormat.selectedPricingMerchandiseOptions || [] : [];

  return (
    <Root className={className}>
      <PricingMerchandiseOptions>
        {pricingMerchandiseOptions.length === 0 ? (
          <Typography>
            <FormattedMessage id="show_project_page.product_options.empty" />
          </Typography>
        ) : (
          pricingMerchandiseOptions.map((pricingMerchandiseOption, index) => (
            <ListItem key={index}>
              <ListItemText
                primary={
                  <>
                    <Typography variant="body2">
                      {pricingMerchandiseOption.name}
                      {pricingMerchandiseOption.helpUrlForDirector ? (
                        <HelpAnchor
                          href={pricingMerchandiseOption.helpUrlForDirector}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <HelpIcon />
                        </HelpAnchor>
                      ) : null}
                    </Typography>
                  </>
                }
              />
            </ListItem>
          ))
        )}
      </PricingMerchandiseOptions>
    </Root>
  );
};

const Root = styled('div')({});

const PricingMerchandiseOptions = styled(_List)({});

const HelpAnchor = styled('a')({
  display: 'inline-flex',
  alignItems: 'center',
  verticalAlign: '-0.3rem',
  marginLeft: SPACING_UNIT,
  color: theme.palette.secondary.main,
  textDecoration: 'none',
});
const HelpIcon = styled(Help)({
  marginRight: 2,
  fontSize: 20,
});

export default PricingMerchandiseOptionsList;
